import api from "@/api";

const state = {
  prizeList: [],
  certificates: [],
  characteristics: [],
  posList: [],
  orderInfo: null,
};

const getters = {
  GET_PRIZE_LIST(state) {
    return state.prizeList;
  },
  GET_CERTIFICATES(state) {
    return state.certificates;
  },
  GET_CHARACTERISTICS(state) {
    return state.characteristics;
  },
  GET_POS_LIST(state) {
    return state.posList;
  },
  GET_ORDER_INFO(state) {
    return state.orderInfo;
  },
};

const mutations = {
  SET_PRIZE_LIST(state, payload) {
    state.prizeList = payload;
  },
  SET_CERTIFICATES(state, payload) {
    state.certificates = payload;
  },
  SET_CHARACTERISTICS(state, payload) {
    state.characteristics = payload;
  },
  SET_POS_LIST(state, payload) {
    state.posList = payload;
  },
  SET_ORDER_INFO(state, payload) {
    state.orderInfo = payload;
  },
};

const actions = {
  async getPrizeList({ commit }) {
    commit({ type: "SET_PRELOADER_INCR" }, { root: true });
    let res = await api.prize.getPrizeList();
    if (res.isSuccess) {
      if (res.result.certificates.length > 0) {
        res.result.items.push({
          name: "Подарочный сертификат",
          description: "Выберите сертификат и номинал для получения подарка. Сертификат будет направлен через сервис Giftery с почты support@giftery.ru",
          // image_url: "https://money.jikiu.ru/upload/iblock/68a/e3kbg6efw1hp1y2ligt80a6yu30kl27m.png",
          image_url: require("@/assets/images/local/certificate.jpg"),
          handler_system_name: "giftery",
        });
      }
      commit("SET_PRIZE_LIST", res.result.items);
      commit("SET_CERTIFICATES", res.result.certificates);
    }
    commit({ type: "SET_PRELOADER_DECR" }, { root: true });
    return res;
  },
  async getPOSList({ commit }) {
    commit({ type: "SET_PRELOADER_INCR" }, { root: true });
    let res = await api.prize.getPOSList();
    if (res.isSuccess) {
      commit("SET_POS_LIST", res.result);
    }
    commit({ type: "SET_PRELOADER_DECR" }, { root: true });
    return res;
  },
  async getCharacteristics({ commit }) {
    commit({ type: "SET_PRELOADER_INCR" }, { root: true });
    let res = await api.prize.getCharacteristics();
    if (res.isSuccess) {
      commit("SET_CHARACTERISTICS", res.result);
    }
    commit({ type: "SET_PRELOADER_DECR" }, { root: true });
    return res;
  },
  updateOrderInfo({ commit }, payload) {
    commit("SET_ORDER_INFO", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
